import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { FaqParagraph, FaqSpan } from './traveler-faqs';
interface FaqRichTextProps {
  paragraph: FaqParagraph;
}
export function FaqRichText(t0) {
  const $ = _c(4);
  const {
    paragraph
  } = t0;
  let t1;
  if ($[0] !== paragraph) {
    t1 = paragraph.map(_temp);
    $[0] = paragraph;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(span, index) {
  return <React.Fragment key={index}>{renderSpan(span)}</React.Fragment>;
}
export function faqPlainText(paragraph: FaqParagraph): string {
  return paragraph.map(span => typeof span === 'string' ? span : span.text).join('');
}
function renderSpan(span: FaqSpan): React.ReactNode {
  if (typeof span === 'string') {
    return span;
  }
  switch (span.kind) {
    case 'emphasis':
      return <em>{span.text}</em>;
    case 'link':
      return <a href={span.href} className="text-primary-main underline underline-offset-2 hover:text-primary-main/70">
          {span.text}
        </a>;
    default:
      {
        const exhaustive: never = span;
        return exhaustive;
      }
  }
}